class ScrollToTop {
    private button: HTMLElement;

    constructor(buttonId: string) {
        const button = document.getElementById(buttonId);
        if (!button) {
            console.warn(`Element with id "${buttonId}" not found.`);
            return;
        }

        this.button = button;
        this.init();
    }

    private init() {
        window.onscroll = () => this.scrollFunction();
        this.button.addEventListener("click", () => this.topFunction());
    }

    private scrollFunction() {
        if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
            this.button.style.display = "flex";
        } else {
            this.button.style.display = "none";
        }
    }

    private topFunction() {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }
}

// Initiera när sidan har laddats
document.addEventListener("DOMContentLoaded", () => {
    if(document.querySelector('.scrollToTop') != undefined && document.querySelector('.scrollToTop') != null) 
    new ScrollToTop("scrollToTop");
});
